var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 19,
    viewBox: "0 0 31 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h31v19H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-201 14H3.29a4 4 0 0 0 2.959-1.31l5.85-6.434a4 4 0 0 1 5.92 0l5.85 6.435A4 4 0 0 0 26.828 14H51c5.523 0 10 4.477 10 10v211.637c0 5.523-4.477 10-10 10h-252c-5.523 0-10-4.477-10-10V24c0-5.523 4.477-10 10-10z",
    id: "d"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.5%",
    y: "-3.7%",
    width: "111%",
    height: "111.6%",
    filterUnits: "objectBoundingBox",
    id: "c"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.108311244 0 0 0 0 0.161009201 0 0 0 0 0.352638134 0 0 0 0.036795236 0",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EAEDF7",
    d: "M14.845 4.452a4.486 4.486 0 0 1 3.258 1.18l6.135 6.722a3.5 3.5 0 0 0 2.59 1.146H51c2.9 0 5.524 1.175 7.425 3.075 1.9 1.9 3.075 4.526 3.075 7.425v211.637c0 2.9-1.175 5.524-3.075 7.424A10.467 10.467 0 0 1 51 246.137h-252c-2.9 0-5.524-1.176-7.425-3.076a10.467 10.467 0 0 1-3.075-7.424V24c0-2.9 1.175-5.524 3.075-7.425 1.9-1.9 4.526-3.075 7.425-3.075H3.29a3.5 3.5 0 0 0 2.589-1.146l5.85-6.435a4.486 4.486 0 0 1 3.116-1.467z",
    fill: "#FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.6034416450507529d1bdb8dc7c51e4c2.svg";
export { ForwardRef as ReactComponent };